export default __webpack_public_path__ + "static/media/supabase-connection.d8d4ef5f.webp";